"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var APIError = /** @class */ (function (_super) {
    __extends(APIError, _super);
    function APIError(message, status, code) {
        var _this = _super.call(this, message) || this;
        _this.name = 'APIError';
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, APIError);
        }
        _this.status = status;
        _this.code = code;
        _this.toJSON = function toJSON() {
            return {
                name: this.name,
                message: this.message,
                status: this.status,
                code: this.code,
                stack: this.stack,
            };
        };
        return _this;
    }
    return APIError;
}(Error));
exports.default = APIError;
//# sourceMappingURL=APIError.js.map